export interface AuditFilter {
  userId: string;
  barcode: string;
  code: string;
  creationDateStart: string;
  creationDateEnd: string;
  postName: string;
  action: string;
  sort: string;
}

// action-state.constants.ts
export const ActionState: string[] = [
  'ENTERED',
  'SAVE',
  'CANCEL',
  'ADVANCE',
  'REJECT',
  'UNREJECT',
  'RECALL',
  'DELETE',
  'DROP',
  'RERUN_REWORK',
  'CASING_EDIT',
  'PROCESS_CODE',
  'WORK_ORDER',
  'CUSTOMER',
  'CIRCUMFERENCE',
  'MISC_CHARGE',
  'REPAIR',
  'SHIP_RECEIVING',
  'TREAD_TYPE',
  'TREAD_WIDTH',
  'CURE_TYPE',
  'CAM_IGNORE',
  'WHEEL_COLOR',
  'WHEEL_TYPE',
  'SHOP_FLOOR_LOCATION',
  'INSPECT_ONLY',
  'ADD NEW REPAIR',
  'ADD EXISTING REPAIR',
  'DELETE NEW REPAIR',
  'DELETE EXISTING REPAIR',
  'MAKE',
  'SERIES',
  'SIZE',
  'DEPTH',
  'APPLICATION',
  'AXLE',
  'GRADE',
  'REMAINING_TREAD_DEPTH',
  'NTR',
  'MDOT',
  'RTDOT',
  'BRAND_NUM',
  'REJECT_REASON',
  'PACK_LIST',
  'STOCK_PROD',
  'SKIVE',
  'IGNORE_CAM_AGE',
  'IGNORE_CAM_NTR',
  'IGNORE_CAM_REP',
  'CASING_NOTE',
  'ADJ_REASON',
  'ADJ_DISPOSITION',
  'ADJ_GRANTED',
  'ADJ_REPAIR',
  'ADJ_CAP_CASING',
  'RFID_TAG_CREATED',
  'RFID_TAG_UPDATED',
  'RFID_TAG_HISTORY_CREATED',
  'RFID_TAG_HISTORY_UPDATED',
  'PLANT_TO_PLANT_TRANSFER',
  'DEALER_RETURN_PROCESSING',
  'D2D_MODIFY_BARCODE',
  'TDMS_PROPERTIES'
];
